<div [ngClass]="{ 'toggle-sidebar': isSidebarOpen }">
  <footer id="footer" class="footer">
    <div class="copyright">
      &copy; Copyright <strong><span>Poocho.pk</span></strong
      >. All Rights Reserved
    </div>
  </footer>
</div>
